export default __webpack_public_path__ + "media/zurb/img/lab/playground/playground-hero-bg2-103d3a67c0924116ea7ef231662f6913.png";